import { InputHTMLAttributes } from 'react'

import s from './Textarea.module.css'

type Props = InputHTMLAttributes<HTMLTextAreaElement> & {
  fullWidth?: boolean
}

export const Textarea = ({
  name,
  placeholder,
  fullWidth,
  value,
  onChange,
  ...rest
}: Props) => {
  return (
    <textarea
      name={name}
      className={`${s.input} ${fullWidth ? s.fullWidth : ''}`}
      placeholder={placeholder}
      onChange={(e) => {
        if (onChange) {
          onChange(e)
        }
      }}
      value={value}
      rows={4}
      {...rest}
      required
    />
  )
}
